import { render, staticRenderFns } from "./RequestResetLinkCard.vue?vue&type=template&id=c16e661e&"
import script from "./RequestResetLinkCard.vue?vue&type=script&lang=ts&"
export * from "./RequestResetLinkCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports